<script setup lang="ts">
defineProps({ blok: Object })

const { state } = useAppStore()
</script>

<template>
    <section class="section">
        <UiContainer max-width="max-w-5xl">
            <header class="global-header">
                <StoryblokRichText :doc="blok?.header" />
            </header>
        </UiContainer>
        <UiContainer max-width="max-w-5xl">
            <header>
                <h3 class="mb-9 font-londrina-solid text-chsc-indigo-500 fs-3xl">
                    {{ blok?.steps_title }}
                </h3>
            </header>
            <div>
                <div class="u-me-steps flex flex-wrap -mx-12 max-[769px]:gap-y-6">
                    <div class="u-me-step-col w-1/2 px-12 relative max-[769px]:w-full">
                        <div
                            class="rounded-[32px] border border-chsc-indigo-500 px-6 py-1.5 flex min-h-full items-center [&>p:first-child]:mr-1.5 [&>p:first-child]:fs-8xl [&>p:first-child]:font-londrina-solid [&>p:first-child]:text-chsc-yellow [&>p:last-child]:fs-2xl [&>p:last-child]:font-londrina-solid [&>p:last-child]:text-chsc-indigo-500"
                        >
                            <p>1</p>
                            <p>{{ blok?.steps_1 }}</p>
                        </div>
                        <div class="absolute top-1/2 left-full -translate-y-1/2 -translate-x-6">
                            <svg
                                width="60"
                                height="36"
                                viewBox="0 0 63 36"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M44 18H0"
                                    stroke="#F8F3FF"
                                    stroke-width="20"
                                />
                                <path
                                    d="M44 33.5858L44 2.32247C44 1.44489 45.0497 0.99293 45.6872 1.596L61.7531 16.7934C62.1622 17.1805 62.1712 17.8288 61.773 18.227L45.7071 34.2929C45.0771 34.9229 44 34.4767 44 33.5858Z"
                                    fill="#F8F3FF"
                                />
                            </svg>
                        </div>
                    </div>
                    <div class="u-me-step-col w-1/2 px-12 max-[769px]:w-full">
                        <div
                            class="rounded-[32px] border border-chsc-indigo-500 px-6 py-1.5 flex min-h-full items-center [&>p:first-child]:mr-1.5 [&>p:first-child]:fs-8xl [&>p:first-child]:font-londrina-solid [&>p:first-child]:text-chsc-yellow [&>p:last-child]:fs-2xl [&>p:last-child]:font-londrina-solid [&>p:last-child]:text-chsc-indigo-500"
                        >
                            <p>2</p>
                            <p>{{ blok?.steps_2 }}</p>
                        </div>
                    </div>
                    <div class="u-me-step-col u-me-step-col--arrow flex w-full justify-center max-[769px]:hidden">
                        <svg
                            width="555"
                            height="74"
                            viewBox="0 0 555 74"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M545 0V7C545 18.0457 536.046 27 525 27H38.5C27.4543 27 18.5 35.9543 18.5 47V54.5"
                                stroke="#F8F3FF"
                                stroke-width="20"
                            />
                            <path
                                d="M2.41422 55L33.6775 55C34.5551 55 35.0071 56.0497 34.404 56.6872L19.2066 72.7531C18.8195 73.1622 18.1712 73.1712 17.773 72.773L1.70711 56.7071C1.07714 56.0771 1.52331 55 2.41422 55Z"
                                fill="#F8F3FF"
                            />
                        </svg>
                    </div>
                    <div class="u-me-step-col w-1/2 px-12 relative max-[769px]:w-full">
                        <div
                            class="rounded-[32px] border border-chsc-indigo-500 px-6 py-1.5 flex min-h-full items-center [&>p:first-child]:mr-1.5 [&>p:first-child]:fs-8xl [&>p:first-child]:font-londrina-solid [&>p:first-child]:text-chsc-yellow [&>p:last-child]:fs-2xl [&>p:last-child]:font-londrina-solid [&>p:last-child]:text-chsc-indigo-500"
                        >
                            <p>3</p>
                            <p>{{ blok?.steps_3 }}</p>
                        </div>
                        <div class="absolute top-1/2 left-full -translate-y-1/2 -translate-x-6">
                            <svg
                                width="60"
                                height="36"
                                viewBox="0 0 63 36"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M44 18H0"
                                    stroke="#F8F3FF"
                                    stroke-width="20"
                                />
                                <path
                                    d="M44 33.5858L44 2.32247C44 1.44489 45.0497 0.99293 45.6872 1.596L61.7531 16.7934C62.1622 17.1805 62.1712 17.8288 61.773 18.227L45.7071 34.2929C45.0771 34.9229 44 34.4767 44 33.5858Z"
                                    fill="#F8F3FF"
                                />
                            </svg>
                        </div>
                    </div>
                    <div class="u-me-step-col w-1/2 px-12 max-[769px]:w-full">
                        <div
                            class="rounded-[32px] border border-chsc-indigo-500 px-6 py-1.5 flex min-h-full items-center [&>p:first-child]:mr-1.5 [&>p:first-child]:fs-8xl [&>p:first-child]:font-londrina-solid [&>p:first-child]:text-chsc-yellow [&>p:last-child]:fs-2xl [&>p:last-child]:font-londrina-solid [&>p:last-child]:text-chsc-indigo-500"
                        >
                            <p>4</p>
                            <p>{{ blok?.steps_4 }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </UiContainer>
        <UiContainer max-width="max-w-5xl">
            <footer class="global-header mt-20">
                <StoryblokRichText :doc="blok?.resume" />
            </footer>
        </UiContainer>
        <UiContainer>
            <header class="global-header">
                <h4 class="text-chsc-indigo-500">
                    {{ blok?.overall_title }}
                </h4>
            </header>
            <div>
                <UiScorecardsKeys />
            </div>
        </UiContainer>
        <UiContainer max-width="max-w-5xl">
            <div class="mt-20 flex items-center gap-x-12 bg-chsc-indigo-500 rounded-3xl p-12 max-[641px]:flex-col max-[641px]:gap-x-0 max-[641px]:gap-y-6">
                <h4 class="w-1/3 text-chsc-yellow fs-6xl font-londrina-solid text-center max-[641px]:w-full">
                    {{ blok?.highlight_title }}
                </h4>
                <p class="flex-1 text-white fs-lg">
                    {{ blok?.highlight_description }}
                </p>
            </div>
        </UiContainer>
    </section>
</template>
